export default __webpack_public_path__ + "static/media/ic_shipment_label.61b6a08e.svg";